<template>
  <div>
    <h5>เชื่อมต่อช่องทางโซเชียล</h5>
    <v-layout wrap class="mt-3">
      <v-flex xs6 class="pt-2">
        <em class="fab fa-facebook-square mr-2" /> เชื่อมต่อกับ facebook
      </v-flex>
      <v-flex xs6>
        <div class="success--text pt-2 pl-2" v-if="selectedBot.page_access_token">
          เชื่อมต่อเรียบร้อย
        </div>
        <div class="" v-else>ยังไม่ได้เชื่อมต่อ</div>
      </v-flex>
    </v-layout>

    <div
      v-if="selectedBot.page_access_token"
      class="arrow mt-2 pa-2"
      style="border: 1px solid #eee; border-radius: 5px"
    >
      <div class="mr-2" style="display: inline-block">
        <v-avatar class="mr-2">
          <img
            class="responsive-img circle"
            style="min-width: 100%"
            alt
            @error="onError"
            :src="
              'https://graph.facebook.com/' +
              (selectedBot.facebook_page_id ? selectedBot.facebook_page_id : selectedBot.pageid) +
              '/picture?width=100&height=100&SameSite=None'
            "
          />
        </v-avatar>
        <span>{{
          selectedBot.facebook_page_name ? selectedBot.facebook_page_name : selectedBot.pagename
        }}</span>
      </div>
    </div>

    <v-layout wrap class="mt-3">
      <v-flex xs6 class="pt-2"><em class="fab fa-line mr-2" /> เชื่อมต่อกับ LINE</v-flex>
      <v-flex xs6>
        <div class="success--text pt-2 pl-2" v-if="selectedBot.line_modular_botid">
          เชื่อมต่อเรียบร้อย
        </div>
        <div v-else>
          <v-btn
            v-if="['premium'].includes($store.getters.getPackage)"
            color="#06b901"
            :href="lineUrl"
            dark
            depressed
          >
            <em class="fab fa-line mr-2" />Connect
          </v-btn>
          <v-btn v-else color="grey" outline>
            Connect<v-premium-lock :inline="true" class="ml-2"></v-premium-lock>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>

    <div
      v-if="selectedBot.line_modular_botid"
      class="arrow mt-2 pa-2"
      style="border: 1px solid #eee; border-radius: 5px"
    >
      <div class="mr-2" style="display: inline-block">Line Connected</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AES from 'crypto-js/aes'
import config from '@/config'
import PageItem from '@/components/view/allbots/PageItem'

export default {
  components: {
    PageItem
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
      availablePages: 'availablePages'
    }),
    computedPage: function () {
      var pages
      try {
        pages = this.availablePages.sort(function (a, b) {
          if (a.tasks.indexOf('MANAGE') > -1 && b.tasks.indexOf('MANAGE') == -1) {
            return -1
          } else if (a.tasks.indexOf('MANAGE') == -1 && b.tasks.indexOf('MANAGE') > -1) {
            return 1
          } else {
            return 0
          }
        })
        if (this.currentPageIndex == null) {
          this.currentPage = null
          return pages
        }
      } catch (error) {
        return []
      }
      try {
        return pages.filter(function (item) {
          if (item.id == this.currentPageIndex) {
            this.currentPage = item
          }
          return item.id == this.currentPageIndex
        })
      } catch (error) {
        console.error(error)
        return pages
      }
    }
  },
  data() {
    return {
      lineUrl: '',
      facebookUrl: '',
      showPageList: false
    }
  },
  mounted() {
    let line_connect_redirect_uri = `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? ':' + window.location.port : ''
    }/connectline`
    let fb_redirect_uri = `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? ':' + window.location.port : ''
    }/autofblogin`

    let query = []

    let state = {
      userid: this.$store.state.userid,
      pageid: this.selectedBot.pageid,
      lang: this.currentLang,
      type: 'connect'
    }

    for (const key in state) {
      if (key != 'state' && key) query.push(`${key}=${state[key]}`)
    }

    let querystring = query.join(',')

    this.facebookUrl = `https://www.facebook.com/v10.0/dialog/oauth?client_id=${
      config.appid
    }&scope=${
      config.fb_scope
    }&return_scopes=true&response_type=token&redirect_uri=${encodeURIComponent(fb_redirect_uri)}`
    if (query && query.length > 0) this.facebookUrl = this.facebookUrl + `&state={${querystring}}`

    let encrypt_query = ''

    encrypt_query = AES.encrypt(querystring, 'awesomezwizai').toString()

    //client id
    //sme 1656036711
    //enterpise 1656186798
    this.lineUrl = `https://manager.line.biz/module/auth/v1/authorize?response_type=code&client_id=1656186798&redirect_uri=${line_connect_redirect_uri}&scope=account:manage%20message:mark_as_read%20message:receive%20message:send%20profile:read&state=${encrypt_query}`
  },
  methods: {
    async onConfirmSubscribe(page) {
      let result = await this.$swal.fire({
        title: this.$t('Do you want to connect this social to this chatbot?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        let data = {
          adminid: this.$store.state.userid,
          pageid: this.selectedBot.pageid,
          page_access_token: page.access_token,
          type: 'connect_facebook_page'
        }
        try {
          let response = await this.post('admin/connect', data, {}, false)
          if (response.success) {
            await this.$swal.fire({
              title: this.$t('Success'),
              type: 'success',
              confirmButtonText: this.$t('Confirm')
            })
          }
          window.location.reload()
        } catch (error) {
          console.log(error)
        }
        this.showPageList = false
      }
    },
    logout() {
      var isFacebook = this.isFacebook
      this.$store.dispatch('logout', null).then()
      if (isFacebook) {
        this.$router.push('/' + this.currentLang + '/login')
      } else {
        this.$router.push('/' + this.currentLang + '/nigol')
      }
    },
    onError: function (event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/SocialConnect.vue